import React, { useContext, useState, useEffect } from "react";
import Page from "components/Page";
import { BuildingContext } from "Context/BuildingProvider";
import { useQuery } from "@apollo/client";
import { GET_SHIFT_CONFIGS } from "lib/buildings";
import { GetShiftConfigsQueryResult } from "generated/graphql";
import StepperFrame, { StepFrame } from "components/Layout/StepperFrame";
import PlaybackControl from "Modules/ShiftPlayback/PlaybackControl";
import { AuthContext } from "Firebase/AuthProvider";
import { LinearProgress } from "@material-ui/core";
import Report from "Modules/Reports/Report";
interface ReportsState {
  shiftNumber?: number;
  shiftDate?: string;
}

const DEFAULT_STATE: ReportsState = {};

export default function Reports() {
  const { currentBuilding } = useContext(BuildingContext);
  const { setRoute } = useContext(AuthContext);
  useEffect(() => {
    setRoute("Reports");
  }, []);
  const [state, setState] = useState(DEFAULT_STATE);
  const { loading, error, data }: GetShiftConfigsQueryResult = useQuery(
    GET_SHIFT_CONFIGS,
    {
      variables: {
        buildingId: currentBuilding?.Id,
      },
    }
  );
  const handleShiftSelected = (activeStep: number) => {
    if (activeStep === 0) {
      console.log(state)
    }
  };

  const handleDateChange = (shiftDate: string) => {
    const newDate = shiftDate + "T00:00:00Z";
    setState({ ...state, shiftDate: newDate });
  };

  const handleShiftChange = (shiftNumber: number) => {
    setState({ ...state, shiftNumber });
  };

  if (loading) {
    return <LinearProgress />;
  } else if (error) {
    return <div>{error.message}</div>;
  } else {
    const stepFrames: StepFrame[] = [
      {
        label: "Choose Shift",
        children: (
          <PlaybackControl
            shiftConfigs={data?.ShiftConfig}
            handleShiftChange={handleShiftChange}
            handleDateChange={handleDateChange}
          />
        ),
      },
      {
        label: "Generate Report",
        children: <Report shiftNumber = {state.shiftNumber} shiftStartDate = {state.shiftDate} buildingId = {currentBuilding?.Id}/>,
      },
    ];
    return (
      <Page title="Report">
        <StepperFrame
          stepFrames={stepFrames}
          cancellable={true}
          handleSubmit={() => {}}
          handleNext={handleShiftSelected}
        />
      </Page>
    );
  }
}
